const staticPixels = "\n<script async src=\"https://www.googletagmanager.com/gtag/js?id=G-W6FD9FK0F1&l=dataLayer\"></script>\n<script async src=\"https://www.googletagmanager.com/gtag/js?id=G-LWN1EPSNTJ&l=dataLayer\"></script>\n<script async src=\"https://www.googletagmanager.com/gtag/js?id=G-PZMKEMTYF1&l=dataLayer\"></script>";
const pixelsCategories = ["STRICTLY_NECESSARY","TARGETING"];

export { staticPixels };
export { pixelsCategories };